
import React from 'react'
import { Box } from '@mui/material'
import AttrezzatureForm from './AttrezzatureForm'
import { useSelector } from 'react-redux'

export const StabilimentiAttrezzatureSlider = ({ cantine, setCantine }) => {
    const singleData = useSelector((store) => store?.attrezzature?.singleAttrezzature)
    console.log(singleData, "datasingle123")
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un’attrezzatura</h2>
            </Box>
            <AttrezzatureForm cantine={cantine} setCantine={setCantine} singleData={singleData} />
        </Box>
    )
}
